import React from 'react';
import {useBymoPageContextProps} from '../../../doppe-sdk';
import {SubscribeActionForm} from '../../../components/subscribe-action-form/subscribe-action-form';
import {evaluateFunction} from '@wix/devzai-utils-common';
import {
    doppeHideableValueGetValue,
    doppeHideableValueIsVisible,
    doppeHideableValueIsVisibleAndNotEqualValue
} from '../../../client-server-common/types/doppe-hideable-value';
import {DoppeActionGoalType, DoppeActionType} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeActionTypeSubscribe,
    SubscribeActionFormSubscriptionOptions
} from '../doppe-action-type-subscribe-metadata';
import {useDoppeViewerLocales} from '../../../client/doppe-viewer-locales/doppe-viewer-locales';
import {useInnerWindowController} from '@wix/devzai-utils-react';

export const DoppeActionTypeSubscribeWidget = React.memo(function DoppeActionTypeSubscribeWidget (
    props: DoppeActionType.WidgetProps<DoppeActionTypeSubscribe.ActionSettings>
) {
    const {
        actionContext,

        ...htmlAttributes
    } = props;

    const action = actionContext.action;

    const actionSettings = action.settings;

    const {
        userDisplayName,
        targetUrl
    } = useBymoPageContextProps();

    const {
        showConsentCheckbox,
        customConsentText,
        customThankYouMessage,
        images,
    } = actionSettings;

    const doppeViewerLocales = useDoppeViewerLocales();
    const windowController = useInnerWindowController();

    return (
        <SubscribeActionForm
            {...htmlAttributes}
            actionContext={actionContext}
            inputIdsNamespace={action.id}
            title={''}
            images={images}
            defaultSubscribeOption={actionSettings.defaultSubscribeOption}
            enableEmailSubscribeOption={actionSettings.enableEmailSubscribeOption}
            enablePhoneSubscribeOption={actionSettings.enablePhoneSubscribeOption}
            consentText={evaluateFunction(() => {

                if (doppeHideableValueIsVisible(customConsentText)) {
                    const customConsentTextValue = doppeHideableValueGetValue(customConsentText).trim();

                    if (customConsentTextValue !== '') {
                        return customConsentTextValue
                    }
                }

                if (showConsentCheckbox) {
                    return doppeViewerLocales['subscribeCheckBoxText']({
                        username: userDisplayName
                    })
                } else {
                    return doppeViewerLocales['subscribeConsentText']({
                        username: userDisplayName
                    })
                }
            })}
            subscribeButtonText={actionSettings.subscribeButtonText}
            showConsentCheckbox={showConsentCheckbox}
            submissionFunction={async (data) => {
                try {
                    await actionContext.addContact({
                        phone: data.subscribeOption === SubscribeActionFormSubscriptionOptions.Phone ?
                            data.phoneNumber :
                            undefined,
                        email: data.subscribeOption === SubscribeActionFormSubscriptionOptions.Email ?
                            data.email :
                            undefined,
                    });

                    actionContext.reportGoalAchieved({
                        goalType: DoppeActionGoalType.Subscribe,
                    });

                    if (windowController) {
                        windowController.closeWindow();
                    }

                    const thankYouText = doppeHideableValueIsVisibleAndNotEqualValue(customThankYouMessage, '') ?
                        doppeHideableValueGetValue(customThankYouMessage) : doppeViewerLocales['subscribeThankYou'];

                    if (targetUrl) {
                        actionContext.redirectToTargetUrl({
                            additionalMessage: thankYouText
                        });
                    }
                    else {
                        actionContext.showNotification({
                            message: thankYouText
                        });
                    }

                } catch (error) {
                    console.error(error);
                }
            }}
        />
    );
});